import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DeliveryViewModel } from '@shared/models/delivery-view.model';
import { Base64 } from '@shared/services/base64.service';
import { properties } from '@env/properties.config';
import { AssingModalComponent } from '../assing-modal/assing-modal.component';
import { MatDialog } from '@angular/material';
import { ModalAlertService } from '@shared/services/modal-alert.service';
import { OrdersAssignmentService } from '@shared/services/order-assigment.service';
import { Messages } from '@shared/enums/messages.enums';
import { BranchViewModel } from '@shared/models/branch-view.model';
import { environment } from '@env/environment';

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent {
  @Input() delivery: DeliveryViewModel;
  @Input() branchTypeId: string;
  @Input() branchId: number;
  @Output() assignation: EventEmitter<any> = new EventEmitter<any>();
  imgServer = environment.imagesServerPath;
  imgDefault = properties.defaultUserImage;

  constructor(
    private dialog: MatDialog,
    private modal: ModalAlertService,
    private orderAssignmentService: OrdersAssignmentService) { }

  getImage(): string {
    return Base64.getPathFromFileNameOrBase64(this.delivery.imageName, this.imgServer, this.imgDefault);
  }

  openAsignModal(): void {
    this.orderAssignmentService.getBranches(this.branchTypeId)
      .subscribe(branches => {
        this.openModal(branches.filter(x => x.id !== this.branchId));
      }, error => this.modal.showAlert({ data: { error: error ? error : Messages.defaultError } }));
  }

  openModal(branches: BranchViewModel[]): void {
    const dialog = this.dialog.open(AssingModalComponent, {
      width: '600px',
      disableClose: true,
      data: {
        data: branches
      }
    });

    dialog.componentInstance.title = 'sucursal';
    dialog.afterClosed().subscribe((branch: BranchViewModel) => {
      if (branch) {
        this.orderAssignmentService.changeDeliveryAssigned({
          DeliveryUserID: this.delivery.id,
          BranchID: branch.id
        }).subscribe((data: any) => {
          this.assignation.emit(this.delivery);
        });
      }
    });
  }
}
